/**
 * The refusal a status change answers with when it would move a Won lead back
 * to an earlier stage: the server explains what that undoes and accepts the
 * same request again once it carries `confirm_backward_transition: true`.
 * Bulk stage changes report it per lead in `failed[].type`.
 */
const BACKWARD_TRANSITION_PENDING_CONFIRMATION = "pending_confirmation"

interface BackwardTransitionConfirmation {
  type: typeof BACKWARD_TRANSITION_PENDING_CONFIRMATION
  message: string
}

const readBackwardTransitionConfirmation = (
  details: unknown
): BackwardTransitionConfirmation | null => {
  const payload = details as
    | { type?: unknown; message?: unknown; detail?: unknown }
    | null
    | undefined
  if (payload?.type !== BACKWARD_TRANSITION_PENDING_CONFIRMATION) return null
  const message = [payload.message, payload.detail].find(
    (value): value is string => typeof value === "string" && !!value.trim()
  )
  return {
    type: BACKWARD_TRANSITION_PENDING_CONFIRMATION,
    message: message ?? ""
  }
}

export {
  BACKWARD_TRANSITION_PENDING_CONFIRMATION,
  readBackwardTransitionConfirmation
}
export type { BackwardTransitionConfirmation }
